export const ORDER_STATUS = [
    "received",
    "preparing",
    "ready",
    "out_for_delivery",
    "delivered",
    "cancelled",
];
/** The transitions the state machine allows. Anything else is a `ConflictError`. */
export const ORDER_STATUS_TRANSITION = Object.freeze({
    received: ["preparing", "cancelled"],
    preparing: ["ready", "cancelled"],
    ready: ["out_for_delivery", "delivered", "cancelled"],
    out_for_delivery: ["delivered", "cancelled"],
    delivered: [],
    cancelled: [],
});
//# sourceMappingURL=order-book.js.map